(function () {
  function initSlider(wrap) {
    if (wrap._sliderReady) return;
    wrap._sliderReady = true;

    var slider = wrap.querySelector('.card-img-slider');
    var prevBtn = wrap.querySelector('.card-img-btn--prev');
    var nextBtn = wrap.querySelector('.card-img-btn--next');
    var slides = wrap.querySelectorAll('.card-img-slide');
    if (!slider || !slides.length) return;

    var total = slides.length;

    // Build thin bar indicators
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'card-img-dots';
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('span');
      dot.className = 'card-img-dot' + (i === 0 ? ' is-active' : '');
      dotsWrap.appendChild(dot);
    }
    wrap.appendChild(dotsWrap);
    var dots = dotsWrap.querySelectorAll('.card-img-dot');

    function getCurrentIndex() {
      return Math.round(slider.scrollLeft / slider.offsetWidth);
    }

    function goTo(index) {
      // Infinite loop wrap
      index = ((index % total) + total) % total;
      slider.scrollTo({ left: index * slider.offsetWidth, behavior: 'smooth' });
    }

    function updateDots() {
      var idx = getCurrentIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        goTo(getCurrentIndex() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        goTo(getCurrentIndex() + 1);
      });
    }

    // Update indicator bars on scroll (covers both swipe and arrow clicks)
    slider.addEventListener('scroll', updateDots, { passive: true });

    // JS-managed hover so arrows stay visible during/after scroll animation
    wrap.addEventListener('mouseenter', function () {
      wrap.classList.add('slider-hovered');
    });
    wrap.addEventListener('mouseleave', function () {
      wrap.classList.remove('slider-hovered');
    });
  }

  function initAllSliders() {
    document.querySelectorAll('.card-img-slider-wrap').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  document.addEventListener('shopify:section:load', initAllSliders);
})();
